(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('AiChatOverlayController', AiChatOverlayController)
        .directive('aiChatOverlay', aiChatOverlay)
        .directive('aiChatOverlayFrameLoaded', aiChatOverlayFrameLoaded);

    AiChatOverlayController.$inject = ['$rootScope', '$scope', '$sce', '$state', '$window', 'AiChat', 'Principal'];

    function AiChatOverlayController($rootScope, $scope, $sce, $state, $window, AiChat, Principal) {
        var vm = this;
        var bootstrapToken = null;
        var clearTokenTimer = null;
        var frameWindow = null;
        var retryTimers = [];
        var stateChangeUnsubscribe = angular.noop;
        var visibilityRequestId = 0;

        vm.aiChatOrigin = null;
        vm.error = false;
        vm.frameReady = false;
        vm.iframeSrc = null;
        vm.isOpen = false;
        vm.isVisible = false;
        vm.loading = false;
        vm.close = close;
        vm.open = open;
        vm.retry = loadBootstrap;
        vm.onIframeLoad = onIframeLoad;

        refreshVisibility();
        Principal.identity().finally(refreshVisibility);

        stateChangeUnsubscribe = $rootScope.$on('$stateChangeSuccess', function() {
            refreshVisibility();
            postPageContext();
        });
        $window.addEventListener('message', onFrameMessage);

        $scope.$on('$destroy', function() {
            $window.removeEventListener('message', onFrameMessage);
            stateChangeUnsubscribe();
            resetFrame();
        });

        function refreshVisibility() {
            var requestId = ++visibilityRequestId;

            if (!Principal.isAuthenticated()) {
                vm.isVisible = false;
                close();
                resetFrame();
                return;
            }

            AiChat.status().then(function(status) {
                if (requestId !== visibilityRequestId) {
                    return;
                }

                vm.isVisible = Boolean(status && status.enabled);

                if (!vm.isVisible) {
                    close();
                    resetFrame();
                }
            }).catch(function() {
                if (requestId !== visibilityRequestId) {
                    return;
                }

                vm.isVisible = false;
                close();
                resetFrame();
            });
        }

        function open() {
            if (!vm.isVisible) {
                return;
            }

            vm.isOpen = true;

            if (!vm.iframeSrc && !vm.loading) {
                loadBootstrap();
            }
        }

        function close() {
            vm.isOpen = false;
        }

        function loadBootstrap() {
            vm.loading = true;
            vm.error = false;
            vm.frameReady = false;
            vm.iframeSrc = null;
            vm.aiChatOrigin = null;
            bootstrapToken = null;

            AiChat.bootstrap().then(function(bootstrap) {
                if (!bootstrap || !bootstrap.token || !bootstrap.aiChatOrigin) {
                    showBootstrapError();
                    return;
                }

                bootstrapToken = bootstrap.token;
                vm.aiChatOrigin = bootstrap.aiChatOrigin;
                vm.iframeSrc = $sce.trustAsResourceUrl(bootstrap.aiChatOrigin);
                vm.loading = false;
            }).catch(function() {
                showBootstrapError();
            });
        }

        function onIframeLoad(loadedFrameWindow) {
            if (!bootstrapToken || !vm.aiChatOrigin || !loadedFrameWindow) {
                return;
            }

            frameWindow = loadedFrameWindow;
            scheduleBootstrapPosts(frameWindow);
            vm.frameReady = true;
        }

        function onFrameMessage(event) {
            if (!event || !event.data || !vm.aiChatOrigin || event.origin !== vm.aiChatOrigin) {
                return;
            }

            if (event.data.type === 'AI_CHAT_ORDER_UPDATED') {
                handleOrderUpdated(event);
                return;
            }

            if (event.data.type !== 'AI_CHAT_READY' || !bootstrapToken) {
                return;
            }

            frameWindow = event.source;
            postBootstrap(event.source, bootstrapToken);
        }

        function handleOrderUpdated(event) {
            var orderId = Number(event.data.orderId);
            if (event.source !== frameWindow ||
                    !isFinite(orderId) || orderId <= 0 || Math.floor(orderId) !== orderId ||
                    (event.data.state !== 'CANCELLED' && event.data.state !== 'TURNAROUND_UPDATED' && event.data.state !== 'TESTS_CANCELLED')) {
                return;
            }

            var stateName = ($state.current && $state.current.name) || '';
            var isMatchingOrderDetails = stateName === 'order-details' &&
                Number($state.params && $state.params.orderId) === orderId;
            if (stateName === 'orders' || stateName === 'home' || isMatchingOrderDetails) {
                $scope.$evalAsync(function() {
                    $state.reload();
                });
            }
        }

        function scheduleBootstrapPosts(frameWindow) {
            var token = bootstrapToken;
            clearRetryTimers();

            [0, 250, 1000, 2500].forEach(function(delay) {
                retryTimers.push($window.setTimeout(function() {
                    postBootstrap(frameWindow, token);
                }, delay));
            });

            clearTokenTimer = $window.setTimeout(function() {
                bootstrapToken = null;
            }, 5000);
        }

        function postBootstrap(targetWindow, token) {
            if (!targetWindow || !vm.aiChatOrigin || !token) {
                return;
            }

            targetWindow.postMessage({
                type: 'AI_CHAT_BOOTSTRAP',
                token: token
            }, vm.aiChatOrigin);
            postPageContext();
        }

        function postPageContext() {
            if (!frameWindow || !vm.aiChatOrigin) {
                return;
            }

            frameWindow.postMessage({
                type: 'AI_CHAT_PAGE',
                stateName: ($state.current && $state.current.name) || '',
                orderId: numericStateParam('orderId'),
                invoiceId: $state.current && $state.current.name === 'invoice-details'
                    ? numericStateParam('id')
                    : undefined,
                paymentId: numericStateParam('paymentId')
            }, vm.aiChatOrigin);
        }

        function numericStateParam(key) {
            var value = Number($state.params && $state.params[key]);
            return isFinite(value) && value > 0 ? value : undefined;
        }

        function clearRetryTimers() {
            retryTimers.forEach(function(timer) {
                $window.clearTimeout(timer);
            });
            retryTimers = [];

            if (clearTokenTimer) {
                $window.clearTimeout(clearTokenTimer);
                clearTokenTimer = null;
            }
        }

        function resetFrame() {
            clearRetryTimers();
            bootstrapToken = null;
            frameWindow = null;
            vm.aiChatOrigin = null;
            vm.error = false;
            vm.frameReady = false;
            vm.iframeSrc = null;
            vm.loading = false;
        }

        function showBootstrapError() {
            vm.loading = false;
            vm.error = true;
            vm.iframeSrc = null;
            clearRetryTimers();
            bootstrapToken = null;
        }
    }

    aiChatOverlay.$inject = ['$animate'];

    function aiChatOverlay($animate) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/ai-chat-overlay/ai-chat-overlay.html',
            controller: 'AiChatOverlayController',
            controllerAs: 'vm',
            link: function(scope, element) {
                // ngAnimate suspends ng-hide's display:none while animating.
                // Rapid minimize/expand clicks interrupt those animations and
                // leave the widget and launcher both stuck visible (plus
                // orphaned leave-clones). No animations are wanted here.
                $animate.enabled(element, false);
            }
        };
    }

    function aiChatOverlayFrameLoaded() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                function onLoad() {
                    scope.$applyAsync(function() {
                        if (scope.vm && scope.vm.onIframeLoad) {
                            scope.vm.onIframeLoad(element[0].contentWindow);
                        }
                    });
                }

                element.on('load', onLoad);
                scope.$on('$destroy', function() {
                    element.off('load', onLoad);
                });
            }
        };
    }
})();
